/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { Avatar } from "@mui/material";
import Link from "@mui/material/Link";

// Argon Dashboard 2 PRO MUI components
import React from "react";
import { useNavigate } from "react-router-dom";

import { useSignOut } from "0.Mine/1.Hooks/security/signout";
import { useSession } from "0.Mine/2.Context/sessionContext";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 PRO MUI context
import { useArgonController } from "context";

// Images

function SidenavFooter() {
  const [controller] = useArgonController();
  const { miniSidenav, darkSidenav } = controller;
  const { signOut } = useSignOut();
  const { session } = useSession();
  const navigate = useNavigate();
  return (
    <ArgonBox opacity={miniSidenav ? 0 : 1} sx={{ transition: "opacity 200ms linear" }}>
      <ArgonBox
        position="relative"
        textAlign="center"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <ArgonBox sx={{ width: "40px", height: "40px", mb: 2 }}>
          <Avatar
            sx={{ width: "100%", height: "100%" }}
            src={session?.user?.image || ""}
            alt={session?.user?.name || "User"}
          />
        </ArgonBox>
        <ArgonBox
          width="100%"
          pb={2}
          px={2}
          color={darkSidenav ? "white" : "dark"}
          textAlign="center"
          lineHeight={0}
        >
          <ArgonTypography color="inherit" variant="h6">
            {session?.user?.name}
          </ArgonTypography>
          <ArgonTypography color="inherit" variant="caption">
            {session?.user?.email}
          </ArgonTypography>
        </ArgonBox>
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column" alignItems="center" px={2}>
        <ArgonButton
          component={Link}
          target="_blank"
          rel="noreferrer"
          color="dark"
          size="small"
          fullWidth
          sx={{ mb: 1, borderRadius: "99px" }}
          onClick={() => navigate("/account")}
        >
          My Account
        </ArgonButton>
        <ArgonButton
          component={Link}
          target="_blank"
          rel="noreferrer"
          onClick={signOut}
          color="info"
          size="small"
          fullWidth
          mb={2}
          sx={{ borderRadius: "99px" }}
        >
          Sign out
        </ArgonButton>
      </ArgonBox>
    </ArgonBox>
  );
}

export default React.memo(SidenavFooter);
